import { ceaser } from "./ceaser";


$(function() {

    if($('body').hasClass('home')){}

	$('.carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $(this).closest('.gallery-block').find('.image-indicator').text(i + '/' + slick.slideCount);
	});

	$('.carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
        fade:true,
		speed:500,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
	});

    $('.hero-text-carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
        fade:false,
		speed:500,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        slidesToShow: 2,
        slidesToScroll: 2,
       // autoplay: true,
       // autoplaySpeed: 5000,
        
        responsive: [
            {
                    breakpoint: 1024,
                    settings: 'unslick'
            }
        ]
	});

     $('.applications-carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
		speed:400,
        fade:false,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        slidesToShow: 4, 
        slidesToScroll: 1,
        infinite:false,
        
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
                    
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
        ]
	});

    $('.gallery-carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
		speed:500,
        fade:false,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        slidesToShow: 1, 
        slidesToScroll: 1,
        infinite:false,
        focusOnSelect: true,
    });

    $('.slider-carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
		speed:400,
        fade:false,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        slidesToShow: 7, 
        slidesToScroll: 1,
        infinite:false,
        
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                },
                    
            },
            {
                breakpoint: 767,
                settings: "unslick",
            },
        ]
	});

    $('.products-carousel').slick({
		draggable:true,
		arrows: false,
        dots:true,
		speed:700,
        fade:false,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        slidesToShow: 1, 
        slidesToScroll: 1,
        infinite:false,
        focusOnSelect: true,

        responsive: [
            
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
	});


    
    $('.ecosystem-carousel').slick({
		
        responsive: [
            {
                breakpoint: 5000,
                settings: "unslick"
            },
            {
                breakpoint: 1024,
                settings: {
                    draggable:true,
                    arrows: false,
                    dots:true,
                    fade:false,
                    speed:500,
                    cssEase: ceaser.easeOutQuart,
                    useTransform:true,
                    rows: 0, // Fix vor v1.8.0-1
                }
            }
        ]
	});

    $('.history-carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    
        if(typeof currentSlide === 'undefined') currentSlide = 0;

	    $('.js-history-nav > li').eq(currentSlide).addClass('active').siblings().removeClass('active');
        move_history_marker(currentSlide);
    });

    $('.history-carousel').slick({
		draggable:true,
		arrows: true,
        dots:false,
        fade:false,
		speed:500,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
        infinite:false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover:true,
        pauseOnFocus:true,
	});


    $('.js-history-nav-link').on('click', function(){

        $(this).closest('li').addClass('active').siblings().removeClass('active');

		var slideIndex = $(this).closest('li').index();

		var _carousel = $('.history-carousel');

			_carousel.slick('slickGoTo', parseInt(slideIndex), true);

			_carousel.find("[data-slick-index='" + slideIndex + "']").focus();

		return false;

	});

    $('.history-carousel .slide:first-child .wp-block-button__link, .js-history-next').on('click', function(){
        var _carousel = $('.history-carousel');
        _carousel.slick('slickNext');
    });
});

function move_history_marker(currentSlide){
    
    var _li = $('.js-history-nav > li').eq(currentSlide);
    if(_li.length > 0){
        var _left = _li.position().left + _li.width()*.5 - 6;
        $('.js-history-marker').css('left', _left + 'px');
        $('.js-history-track').css('width', _left + 'px');
    }
    
}